import React from 'react';

const EulaComponent = () => {
    return (
        <div style={{ textAlign: 'center' }}>
      This End User License Agreement
        </div>
    );
};

export default EulaComponent;
